import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackPromotionalEventsPdpPromoBannerClick } from "@faire/web-api--source/events/promotionalEvents/click/pdpPromoBanner";
import { trackPromotionalEventsPdpPromoBannerView } from "@faire/web-api--source/events/promotionalEvents/view/pdpPromoBanner";
import { IInformationMessage } from "@faire/web-api--source/indigofair/data/IInformationMessage";
import { observer } from "mobx-react";
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { FormattedText } from "@faire/retailer/components/FormattedText";
import { SERRANO } from "@faire/retailer-visitor-shared/consts/colors";
import { useAssignSettingUpdateSaleColorCopy, useSettingUpdateSaleColorCopy } from "@faire/retailer/settings/useSettingUpdateSaleColorCopy";
var SimpleProductPromoBase = function(props) {
    var _props_promotions, _props_promotions1;
    var _useState = _sliced_to_array(useState(-1), 2), tooltipIndex = _useState[0], setTooltipIndex = _useState[1];
    var toggleTooltip = React.useCallback(function(index) {
        setTooltipIndex(function(oldIndex) {
            return oldIndex === index ? -1 : index;
        });
    }, []);
    var _props_promotions_length;
    if (((_props_promotions_length = (_props_promotions = props.promotions) === null || _props_promotions === void 0 ? void 0 : _props_promotions.length) !== null && _props_promotions_length !== void 0 ? _props_promotions_length : 0) === 0) {
        return null;
    }
    var filteredPromotions = (_props_promotions1 = props.promotions) === null || _props_promotions1 === void 0 ? void 0 : _props_promotions1.filter(function(promo) {
        var _promo_position;
        var bannerPosition = (_promo_position = promo.position) !== null && _promo_position !== void 0 ? _promo_position : IInformationMessage.Position.DEFAULT;
        return promo.type !== IInformationMessage.Type.CATEGORY_RESTRICTION && bannerPosition === props.position;
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: filteredPromotions === null || filteredPromotions === void 0 ? void 0 : filteredPromotions.map(function(productPromotion, index) {
            return /*#__PURE__*/ _jsx(SimplePromotionBanner, {
                productPromotion: productPromotion,
                index: index,
                toggleTooltip: toggleTooltip,
                tooltipIndex: tooltipIndex
            }, index);
        })
    });
};
export var SimpleProductPromo = observer(SimpleProductPromoBase);
var SimplePromotionBanner = function(param) {
    var productPromotion = param.productPromotion, index = param.index, toggleTooltip = param.toggleTooltip, tooltipIndex = param.tooltipIndex;
    var assignUpdateSaleColorCopy = useAssignSettingUpdateSaleColorCopy();
    useEffect(function() {
        assignUpdateSaleColorCopy();
    }, [
        assignUpdateSaleColorCopy
    ]);
    var isUpdateSaleColorCopy = useSettingUpdateSaleColorCopy();
    var viewRef = useDoActionWhenVisible(function() {
        var _productPromotion_type;
        return trackPromotionalEventsPdpPromoBannerView((_productPromotion_type = productPromotion.type) !== null && _productPromotion_type !== void 0 ? _productPromotion_type : IInformationMessage.Type.TYPE_UNKNOWN);
    });
    var renderTooltip = useCallback(function(index, productPromotion) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "\xa0",
                /*#__PURE__*/ _jsxs(Tooltip, {
                    isOpen: tooltipIndex === index,
                    innerClassName: "tooltip-inner",
                    pointerOffset: 130,
                    children: [
                        productPromotion.tooltip,
                        productPromotion.help_link ? /*#__PURE__*/ _jsx(EmbeddedLink, {
                            target: "_blank",
                            linkTo: productPromotion.help_link,
                            color: Core.text.inverse,
                            onClick: function() {
                                var _productPromotion_type;
                                trackPromotionalEventsPdpPromoBannerClick((_productPromotion_type = productPromotion.type) !== null && _productPromotion_type !== void 0 ? _productPromotion_type : IInformationMessage.Type.TYPE_UNKNOWN);
                                toggleTooltip(index);
                            },
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "7DIW6+",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Learn More"
                                    }
                                ]
                            })
                        }) : null
                    ]
                })
            ]
        });
    }, [
        toggleTooltip,
        tooltipIndex
    ]);
    return /*#__PURE__*/ _jsx(SimplePromotionContainer, {
        ref: viewRef,
        onClick: function() {
            return toggleTooltip(index);
        },
        "data-test-id": "simpleProductPromo:".concat(productPromotion.type),
        children: /*#__PURE__*/ _jsxs(Typography, {
            color: isUpdateSaleColorCopy ? SERRANO : Decorative.shade.orange,
            children: [
                /*#__PURE__*/ _jsx(FormattedText, {
                    text: productPromotion.text
                }),
                productPromotion.tooltip ? renderTooltip(index, productPromotion) : null
            ]
        })
    });
};
var SimplePromotionContainer = styled(Row).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-1a757748-0"
})([
    "width:100%;"
]);
